export function I18n(config, key) {
  return {
    CN: {
      Grand_Total: '总计',
      Order_Number: '订单编号',
      Card_Type: '信用卡类型：',
      Level_One_Label: '请输入您的信用卡信息',
      Card_Number: '信用卡号：',
      Card_No_Required: '请输入信用卡卡号',
      Card_No_Max: '信用卡号不能超过200个字符',
      Cvv2_Required: '请输入信用卡背面签名条一串数字的后三位',
      Cvv2_Max: '必须为三位字符',
      Expiry_Date: '有效日期：',
      Card_Expire_Required: '请选择信用卡有效期',
      Card_Lssuing_Bank: '发卡银行：',
      Issuing_Bank_Required: '请输入发卡银行',
      Issuing_Bank_Max: '长度不能超过255个字符',
      Expiry_Date_Placeholder: '请选择年月',
      Level_Two_Label: '请输入您的信用卡账单地址',
      First_Name: '名：',
      First_Name_Required: '请输入您的名字',
      First_Name_Max: '长度不能超过100个字符',
      Last_Name: '姓：',
      Last_Name_Required: '请输入您的姓氏',
      Last_Name_Max: '长度不能超过50个字符',
      Address: '地址：',
      Address_Required: '请输入详细地址',
      Address_Max: '长度不能超过500个字符',
      City_Town: '城市/镇：',
      City_Required: '请输入城市/镇',
      City_Max: '长度不能超过100个字符',
      Country_Region: '国家/地区：',
      Country_Required: '请选择国家/地区',
      State_Province: '州/省：',
      Postcode_Zip: '邮政编码：',
      Zip_Required: '请输入邮政编码',
      Zip_Max: '长度不能超过100个字符',
      Email: '电子邮箱：',
      Email_Required: '请输入电子邮箱',
      Email_Max: '长度不能超过200个字符',
      Phone: '电话：',
      Phone_Required: '请输入电话号码',
      Phone_Max: '长度不能超过50个字符',
      CN: '中国大陆',
      HK: '中国香港',
      MO: '中国澳门',
      TW: '中国台湾',
      AF: '阿富汗',
      AX: '奥兰群岛',
      AL: '阿尔巴尼亚',
      DZ: '阿尔及利亚',
      AS: '美属萨摩亚群岛',
      AD: '安道尔',
      AO: '安哥拉',
      AI: '安吉拉',
      AQ: '南极洲',
      AG: '安提瓜和巴布达',
      AR: '阿根廷',
      AM: '亚美尼亚',
      AW: '阿鲁巴',
      AU: '澳大利亚',
      AT: '奥地利',
      AZ: '阿塞拜疆',
      BS: '巴哈马',
      BH: '巴林',
      BD: '孟加拉国',
      BB: '巴巴多斯',
      BY: '白俄罗斯',
      BE: '比利时',
      BZ: '伯利兹',
      BM: '百慕大群岛',
      BT: '不丹',
      BO: '玻利维亚',
      BO: '波斯尼亚和黑塞哥维那',
      BW: '博茨瓦纳',
      BV: '布瓦岛',
      BR: '巴西',
      IO: '英属印度洋领地',
      BN: '文莱达鲁萨兰国',
      BG: '保加利亚',
      BF: '布基纳法索',
      BI: '布隆迪',
      KH: '柬埔寨',
      CM: '喀麦隆',
      CA: '加拿大',
      CV: '佛得角',
      KY: '开曼群岛',
      CF: '中非共和国',
      TD: '乍得',
      CL: '智利',
      CX: '圣诞岛',
      CC: '科科斯（基林）群岛',
      CO: '哥伦比亚',
      KM: '科摩罗',
      CG: '刚果',
      CD: '刚果民主共和国',
      CK: '库克群岛',
      DR: '哥斯达黎加',
      CI: '科特迪瓦',
      HR: '克罗地亚',
      CU: '古巴',
      CY: '塞浦路斯',
      CZ: '捷克共和国',
      DK: '丹麦',
      DJ: '吉布提',
      DM: '多米尼加',
      DO: '多明尼加共和国',
      EC: '厄瓜多尔',
      EG: '埃及',
      SV: '萨尔瓦多',
      GQ: '赤道几内亚',
      ER: '厄立特里亚',
      EE: '爱沙尼亚',
      ET: '埃塞俄比亚',
      FK: '福克兰群岛（马尔维纳斯）',
      FO: '法罗群岛',
      FJ: '斐济',
      FI: '芬兰',
      FR: '法国',
      GF: '法属圭亚那',
      Agree_Text: '我已阅读并同意',
      Agree_Ag: '请阅读并同意相关服务协议'

    },
    HK: {
      Grand_Total: '總計',
      Order_Number: '訂單編號',
      Card_Type: '信用卡類型：',
      Level_One_Label: '請輸入您的信用卡信息',
      Card_Number: '信用卡號：',
      Card_No_Required: '請輸入信用卡卡號',
      Card_No_Max: '信用卡號不能超過200個字符',
      Cvv2_Required: '請輸入信用卡背面簽名條一串數字的後三位',
      Cvv2_Max: '必須為三位字符',
      Expiry_Date: '有效日期：',
      Card_Expire_Required: '請選擇信用卡有效期',
      Card_Lssuing_Bank: '發卡銀行：',
      Issuing_Bank_Required: '請輸入發卡銀行',
      Issuing_Bank_Max: '長度不能超過255個字符',
      Expiry_Date_Placeholder: '請選擇年月',
      Level_Two_Label: '請輸入您的信用卡賬單地址',
      First_Name: '名：',
      First_Name_Required: '請輸入您的名字',
      First_Name_Max: '長度不能超過100個字符',
      Last_Name: '姓：',
      Last_Name_Required: '請輸入您的姓氏',
      Last_Name_Max: '長度不能超過50個字符',
      Address: '地址：',
      Address_Required: '請輸入詳細地址',
      Address_Max: '長度不能超過500個字符',
      City_Town: '城市/鎮：',
      City_Required: '請輸入城市/鎮',
      City_Max: '長度不能超過100個字符',
      Country_Region: '國家/地區：',
      Country_Required: '請選擇國家/地區',
      State_Province: '州/省：',
      Postcode_Zip: '郵政編碼：',
      Zip_Required: '請輸入郵政編碼',
      Zip_Max: '長度不能超過100個字符',
      Email: '電子郵箱：',
      Email_Required: '請輸入電子郵箱',
      Email_Max: '長度不能超過200個字符',
      Phone: '電話：',
      Phone_Required: '請輸入電話號碼',
      Phone_Max: '長度不能超過50個字符',
      HK: '中國香港',
      CN: '中國大陸',
      MO: '中國澳門',
      TW: '中國台灣',
      AF: '阿富汗',
      AX: '奧蘭群島',
      AL: '阿爾巴尼亞',
      DZ: '阿爾及利亞',
      AS: '美屬薩摩亞群島',
      AD: '安道爾',
      AO: '安哥拉',
      AI: '安吉拉',
      AQ: '南極洲',
      AG: '安提瓜和巴布達',
      AR: '阿根廷',
      AM: '亞美尼亞',
      AW: '阿魯巴',
      AU: '澳大利亞',
      AT: '奧地利',
      AZ: '阿塞拜疆',
      BS: '巴哈馬',
      BH: '巴林',
      BD: '孟加拉國',
      BB: '巴巴多斯',
      BY: '白俄羅斯',
      BE: '比利時',
      BZ: '伯利茲',
      BM: '百慕大群島',
      BT: '不丹',
      BO: '玻利維亞',
      BA: '波斯尼亞和黑塞哥維那',
      BW: '博茨瓦納',
      BV: '佈瓦島',
      BR: '巴西',
      IO: '英屬印度洋領地',
      BN: '文萊達魯薩蘭國',
      BG: '保加利亞',
      BF: '佈基納法索',
      BI: '佈隆迪',
      KH: '柬埔寨',
      CM: '喀麥隆',
      CA: '加拿大',
      CV: '佛得角',
      KY: '開曼群島',
      CF: '中非共和國',
      TD: '乍得',
      CL: '智利',
      CX: '聖誕島',
      CC: '科科斯（基林）群島',
      CO: '哥倫比亞',
      KM: '科摩羅',
      CG: '剛果',
      CD: '剛果民主共和國',
      CK: '庫克群島',
      DR: '哥斯達黎加',
      CI: '科特迪瓦',
      HR: '克羅地亞',
      CU: '古巴',
      CY: '塞浦路斯',
      CZ: '捷克共和國',
      DK: '丹麥',
      DJ: '吉佈提',
      DM: '多米尼加',
      DO: '多明尼加共和國',
      EC: '厄瓜多爾',
      EG: '埃及',
      SV: '薩爾瓦多',
      GQ: '赤道幾內亞',
      ER: '厄立特里亞',
      EE: '愛沙尼亞',
      ET: '埃塞俄比亞',
      FK: '福克蘭群島（馬爾維納斯）',
      FO: '法羅群島',
      FJ: '斐濟',
      FI: '芬蘭',
      FR: '法國',
      GF: '法屬圭亞那',
      Agree_Text: '我已閱讀並同意',
      Agree_Ag: '請閱讀並同意相關服務協議'
    }
  } [config][key]
}

export const countryMap = [
  'CN', 'HK', 'MO', 'TW'
]

// 'AF', 'AX', 'AL', 'DZ', 'AS', 'AD', 'AO', 'AI', 'AQ', 'AG', 'AR', 'AM', 'AW', 'AU', 'AT', 'AZ',
//   'BS', 'BH', 'BD', 'BB', 'BY', 'BE', 'BZ', 'BN', 'BM', 'BT', 'BO', 'BA', 'BW', 'BV', 'BR', 'IO', 'BN', 'BG', 'BF', 'BI',
//   'KH', 'CM', 'CA', 'CV', 'KY', 'CF', 'TD', 'CL', 'CX', 'CC', 'CO', 'KM', 'CG', 'CD', 'CK', 'DR', 'CI', 'HR', 'CU', 'CY', 'CZ',
//   'DK', 'DJ', 'DM', 'DO', 'EC', 'EG', 'SV', 'GQ', 'ER', 'EE', 'ET', 'FK', 'FO', 'FJ', 'FI', 'FR', 'GF'